import React, { Component } from "react";
import styled from "styled-components";

import Dropdown from "./Dropdown.js";
import Icon from "../UI/Icon";

import baseStyles from "../../styles/baseStyles";
import ChevronDown from "../../assets/icons/chevron-down.svg";
import ChevronUp from "../../assets/icons/chevron-up.svg";

const Label = styled.li`
  display: flex;
  align-items: center;
  font-family: Lato;
  white-space: nowrap;
  & span {
    text-transform: uppercase;
  }
  font-weight: 300;
  color: ${baseStyles.color.gray};
  & span {
    padding-right: 0.5rem;
  }
  cursor: pointer;
  :not(:last-of-type) {
    margin-right: 3rem;
  }
`;

class FilterLabel extends Component {
  state = {
    showDropdown: false
  };

  render() {
    return (
      <Label
        key={this.props.label}
        onMouseEnter={() => this.setState({ showDropdown: true })}
        onMouseLeave={() => this.setState({ showDropdown: false })}
      >
        <span>{this.props.label}</span>
        <Icon iconRef={ChevronDown} size={1} />
        <Dropdown
          selectedAll={this.props.selectedAll}
          options={this.props.options}
          show={this.state.showDropdown}
          onCheckboxChanged={label =>
            this.props.onCheckboxChanged(label, this.props.label)
          }
          onSelectAll={() => this.props.onSelectAll(this.props.label)}
        />
      </Label>
    );
  }
}

export default FilterLabel;



// WEBPACK FOOTER //
// ./src/components/FilterBar/FilterLabel.js